module.exports = __webpack_public_path__ + "img/sb.67dafd60.png";